module.exports = __webpack_public_path__ + "static/media/landing_bg.d019ef1d.jpg";